import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import PropTypes from 'prop-types';
import metadata from './AddtlInterestExcludedDriverComponent.metadata.json5';
import messages from './AddtlInterestExcludedDriverComponent.messages';
import styles from './AddtlInterestExcludedDriverComponent.module.scss';
import { AccountService } from 'gw-capability-gateway-policy';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';

import appConfig from 'app-config';

function AddtlInterestExcludedDriverComponent(props) {
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        value: driverVM,
        index,
        policyAddress: addressVM,
        id,
        path,
        onValueChange,
        onValidate,
        showValidationErrors,
        isGpa,
        canEditEmailFields,
        isModernProduct,
        submissionVM
    } = props;
    const {
        onValidate: setComponentValidation,
        isComponentValid,
    } = useValidation(id);

    const isQnB = appConfig.portalCode === 'QB';

    const { authHeader } = useAuthentication();
    const isEsignOptionSelected = _.get(submissionVM, 'bindData.esignature_ML.esignatureOptions.value');

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        addWarningAlert,
        clearBlockAlerts,
    } = MLNotificationBlockUtil();

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const isInCO = () => {
        return addressVM.state.value && addressVM.state.value.code === 'CO';
    };

    const isInGA = () => {
        return addressVM.state.value && addressVM.state.value.code === 'GA';
    };

    const isInUT = () => {
        return addressVM.state.value && addressVM.state.value.code === 'UT';
    };

    const isInOR = () => {
        return addressVM.state.value && addressVM.state.value.code === 'OR';
    };

    const getDriverName = () => {
        let name = _.startCase(_.toLower(driverVM.value.person.displayName));
        const suffixVal = _.get(driverVM, 'person.suffix.value.code', undefined);
        if (suffixVal) {
            const suffixTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
            const suffixName = suffixTypelist.getCode(suffixVal).name;
            name += ' ';
            name += translator({
                id: suffixName,
                defaultMessage: suffixName
            });
        }
        return name;
    };


    const writeValue = useCallback((value, changedPath) => {
        onValueChange(value, `${path}.${changedPath}`);
    }, [onValueChange, path]);

    const ageFirstLicensedVisible = useCallback(() => {
        const ageFirstRequiredAspect = _.get(driverVM, 'ageFirstLicensed_ML.aspects.required', undefined);
        if (_.isUndefined(ageFirstRequiredAspect) || ageFirstRequiredAspect === 'false') {
            return false;
        }
        return true;
    }, [driverVM]);

    const isExcludedAgeFirstLicensed = () => {
        return addressVM.state.value.code === 'OK' || addressVM.state.value.code === 'MO' || addressVM.state.value.code === 'AK';
    };

    const disableDriverEmailField = (driver) => {
        return (isGpa && !canEditEmailFields && _.get(driver, 'value.storedEmailAddress_ML'));
    };

    const validateEmailAddress = (driverVM) => {
        const account = driverVM;
        let emailAddress1 =  _.get(account, 'person.emailAddress_ML.value');
        if(emailAddress1){
            emailAddress1=emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(account, 'person.emailVerified_Ext.value', true);
                    _.set(account, 'person.emailAddress_ML.value', emailAddress1);
                }
                else{
                    _.set(account, 'person.emailVerified_Ext.value', false);
                    _.set(account, 'person.emailAddress_ML.value', emailAddress1 + ' ');
                    // updateShowErrors(true);
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmailId');
                addWarningAlert(translator(messages.invalidEmailId), 'invalidEmailId');
                _.set(account, 'person.emailAddress_ML.value', emailAddress1);
                _.set(account, 'emailVerified_Ext.value', false);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        } 
    };

    const emailTrim = (driverVM) => {
        let currEmail = _.get(driverVM, 'person.emailAddress_ML.value');
        if(currEmail !== '' && currEmail !== undefined){
            currEmail = currEmail.trim();
            _.set(driverVM, 'person.emailAddress_ML.value', currEmail);
        }
    }    

    const overrideProps = {
        excludedDriverx: {
            content: translator(messages.excludedDriverx, { driverIndex: (index + 1) })
        },
        driverName: {
            content: getDriverName()
        },
        excludedDriverEmailAddressContainer: {
            visible: !isGpa && (isInCO() || isInGA() || isInUT() || isInOR())
        },
        driverEmailAddress: {
            disabled: disableDriverEmailField(driverVM),
            showValidationErrors: showValidationErrors,
        },
        driverEmailAddressExcluded: {
            disabled: disableDriverEmailField(driverVM),
            showValidationErrors: showValidationErrors
        },
        ageFirstLicensed: {
            visible: ageFirstLicensedVisible()
        },
        driverSeparator: {
            visible: !isGpa
        },
        qnbExcludedDriverHeader: {
            visible: !isGpa
        },
        gatewayExcludedDriverHeader: {
            visible: isGpa
        },
        gatewayExcludedDriverName: {
            content: `${getDriverName()} ${translator(messages.gatewayExcludedDriverX, { driverNumber: (index + 1) })}`
        },
        hrLine: {
            visible: !isGpa
        },
        gatewayExcludedDriverEmailAddressContainer: {
            visible: isGpa && (isInGA() || isInUT() || isInOR()) && !isModernProduct,
            onBlur: (() => validateEmailAddress(driverVM)),
            onFocus: (() => emailTrim(driverVM))
        },
        ageFirstLicensedContainer: {
            visible: (isGpa && isExcludedAgeFirstLicensed()) || (!isGpa && driverVM.ageFirstLicensed_ML.aspects.required)
        },
        excludedDriverStateLicenseContainerChild: {
            className: isQnB ? "toolTipQB" : "col-md-4"
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            overrideProps={overrideProps}
            model={driverVM}
            onValidationChange={setComponentValidation}
            onValueChange={writeValue}
            showErrors={showValidationErrors}
        />
    );
}

AddtlInterestExcludedDriverComponent.propTypes = {
    value: PropTypes.shape({}).isRequired,
    id: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    policyAddress: PropTypes.shape({}).isRequired,
    path: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    isGpa: PropTypes.bool
};

AddtlInterestExcludedDriverComponent.defaultProps = {
    isGpa: false
}

export default AddtlInterestExcludedDriverComponent;
